import { jsx as i } from "react/jsx-runtime";
import { cn as s } from "../../../lib/utils.mjs";
import { PaginationEllipsisVariants as t } from "./PaginationEllipsisVariants.mjs";
import n from "../../Icon/Icon.mjs";
const l = ({
  className: a,
  variant: o = "default",
  ...r
}) => /* @__PURE__ */ i(
  "span",
  {
    "aria-hidden": !0,
    className: s(t({
      variant: o
    }), a),
    ...r,
    children: /* @__PURE__ */ i(n, { icon: "material-symbols--more-horiz", width: 5, height: 5 })
  }
);
l.displayName = "PaginationEllipsis";
export {
  l as default
};
//# sourceMappingURL=PaginationEllipsis.mjs.map
